import React from 'react';
import PropTypes from 'prop-types';
import {ProgressSpinner} from "primereact/progressspinner";


class Spinner extends React.Component{

    render() {

        return(
            <div align="center" style={{
                    display: this.props.loadingState?'block':'none',
                    position: 'fixed',
                    backgroundColor: 'rgba(111,110,110,0.9)',
                    zIndex: '6000',
                    width:'100%',
                    height:'100%',
                    overflow: 'visible',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0}}>
                    <ProgressSpinner
                        style={{marginTop:'250px',zIndex: '4'}}
                        strokeWidth="4"
                        fill="#EEEEEE">
                    </ProgressSpinner>
            </div>
        )
    }
}
Spinner.propTypes = {
    loadingState: PropTypes.bool,
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/spinner/Spinner.jsx